import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { InfoMarkCircle } from '@finam/web-ui-kit/Icons/InfoMark';
import styled from 'styled-components';
import ButtonBase from '../../Core/Button';
import Link from '../../Core/Link';
export var DescriptionIconWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n"])));
export var LinkWrap = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding-top: 16px;\n"])));
export var SecondaryButton = styled(ButtonBase).attrs({
  variant: 'secondary'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 16px;\n"])));
export var InfoMarkCircleIcon = styled(InfoMarkCircle)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  && {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.label.plaseholder;
});
export var RecoveryLink = styled(Link)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-bottom: 16px;\n"])));